import { render, staticRenderFns } from "./quote-list.vue?vue&type=template&id=25fd334a&scoped=true&"
import script from "./quote-list.vue?vue&type=script&lang=js&"
export * from "./quote-list.vue?vue&type=script&lang=js&"
import style0 from "./quote-list.vue?vue&type=style&index=0&id=25fd334a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fd334a",
  null
  
)

export default component.exports